import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import { formatDate, timeAgo } from "../utils/format.ts";

type HeartbeatColor = "error" | "warning" | "success" | "default";

function computeHeartbeat(iso: string | null): { label: string; color: HeartbeatColor; title: string } {
  if (!iso) return { label: "Never", color: "default", title: "No heartbeat received" };
  const seconds = (Date.now() - new Date(iso).getTime()) / 1000;
  const title = formatDate(iso, "full");
  if (seconds >= 300) return { label: "Offline", color: "error", title };
  return { label: timeAgo(iso, { seconds: true }), color: seconds < 120 ? "success" : "warning", title };
}

export default function HeartbeatChip({ iso }: { iso: string | null }) {
  const [, tick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => tick((n) => n + 1), 5_000);
    return () => clearInterval(id);
  }, []);

  const { label, color, title } = computeHeartbeat(iso);
  return (
    <Tooltip title={title}>
      <Chip size="small" label={label} color={color} variant="outlined" />
    </Tooltip>
  );
}
